var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._l((4),function(tier){return _c('DarkMatterDimensionRow',{key:tier,attrs:{"tier":tier}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }